import { createReducer, on } from '@ngrx/store';
import { fromRulerActions } from './ruler.action';
import { rulerAdapter, rulerInitialState, RulerState } from './ruler.state';

export const rulerReducer = createReducer(
  rulerInitialState,

  on(fromRulerActions.AddRuler, (state, { ruler }) =>
    rulerAdapter.addOne(ruler, state)
  ),

  on(fromRulerActions.DeleteRuler, (state, { id }) =>
    rulerAdapter.removeOne(id, {
      ...state,
      selectedRulerId: state.selectedRulerId === id ? null : state.selectedRulerId,
    })
  ),

  on(fromRulerActions.SelectRuler, (state, { id }) => ({
    ...state,
    selectedRulerId: id,
  })),

  on(fromRulerActions.UpdateRulerDistance, (state, { id, distanceInFeet, endPoint }) =>
    rulerAdapter.updateOne({ id, changes: { distanceInFeet, endPoint } }, state)
  ),

  on(fromRulerActions.ClearAllRulers, (state) =>
    rulerAdapter.removeAll({ ...state, selectedRulerId: null })
  ),

  on(fromRulerActions.AddManyRulers, (state, { rulers }) =>
    rulerAdapter.setAll(rulers, { ...state, selectedRulerId: null })
  )
);

export { RulerState };
